import { useState } from "react"

export const useIndicateClass = () => {
    const [state, setState] = useState(0);
    const reIndicateClass = () => setState(state+1);
    return { reIndicateClassAction: reIndicateClass, reIndicateClassState: state };
}